export const SITE_ORIGIN = 'https://nova.plainbit.co.kr';
export const SITE_NAME = 'Nova';
export const OG_IMAGE = `${SITE_ORIGIN}/assets/images/logo-nova-lg.png`;

export const ROUTES = {
  index: '/',
  plan: '/plan',
  demo: '/demo',
  inquiry: '/inquiry',
};

/** 데모 화면이 확정되면 false 로 바꾸면 안내 알럿·리다이렉트가 사라진다 */
export const DEMO_COMING_SOON = true;
export const DEMO_COMING_SOON_MESSAGE = '준비 중인 기능입니다.';

/** 옛 정적 페이지 주소 → 새 라우트. 서버 301 이 없어도 링크가 살아있게 한다 */
export const LEGACY_PATHS = {
  '/index.html': ROUTES.index,
  '/plan.html': ROUTES.plan,
  '/demo.html': ROUTES.demo,
  '/inquiry.html': ROUTES.inquiry,
};

export const GNB_ITEMS = [
  { label: 'Nova', to: ROUTES.index },
  { label: 'Plan', to: ROUTES.plan },
  { label: 'Demo', to: ROUTES.demo },
];
